import { Button as AntButton, Modal, Table, TableColumnsType } from "antd";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getSurveyResult3Detail } from "../../../../api/surveyQuestion.api";
import useAxios from "../../../../hooks/useAxios";
import config from "../../../../lib/config";
import { IGetSurveyResult3Detail, ISurveyResult3Detail, ISurveyResultParams } from "../../../../models/surveyQuestion.model";
import { RootState } from "../../../../store/rootReducer";
import ErrorResponse from "../../../ErrorResponse";
import Loader from "../../../Loader";
import Pagination from "../../../Pagination";
import ResultSearchBar from "../ResultSearchBar";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  surveyCode: number|undefined;
  questionCode: number|undefined;
}

const SurveyResult3DetailModal: FC<IProps> = ({
  visible,
  setVisible,
  surveyCode,
  questionCode,
}) => {
  const { t } = useTranslation();
  const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetSurveyResult3Detail>();

  const [pageNo, setPageNo] = useState(1);
  const [campusCode, setCampusCode] = useState('');
  const [courseCode, setCourseCode] = useState('');

  useEffect(() => {
    if (surveyCode && questionCode) {
      doGetSurveyResult3Detail();
    }
  }, [surveyCode, questionCode, pageNo]);

  const doGetSurveyResult3Detail = (_pageNo?: number) => {
    if (!surveyCode || !questionCode) return;

    const req: ISurveyResultParams = {
      pageNo: _pageNo || pageNo,
      perPage: config.miniPageSize,
    };

    if (auth.hqYn === 'Y') {
      if (campusCode) req.campusCode = campusCode;
    } else {
      req.campusCode = currentCampus;
    }
    if (courseCode) req.courseCode = courseCode;

    execute(getSurveyResult3Detail(surveyCode, questionCode, req));
  }

  const onSearch = () => {
    doGetSurveyResult3Detail(1);
  }

  const columns: TableColumnsType<ISurveyResult3Detail> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusName',
      key: 'campusName',
      align: 'center',
    },
    {
      title: t('homepage.archive.column4'),
      dataIndex: 'courseName',
      key: 'courseName',
      align: 'center',
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      key: 'className',
      align: 'center',
    },
    {
      title: t('event.education.column22'),
      dataIndex: 'memberName',
      key: 'memberName',
      align: 'center',
    },
    {
      title: t('common.column.contents'),
      dataIndex: 'questionContent',
      key: 'questionContent',
      align: 'center',
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Modal
        title={t('homepage.survey.title5')}
        visible={visible}
        width={750}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <div className="flex flex-justify-between">
          <div className="v-line">{t('archive.exam.text1')}: {res?.total || 0}</div>
          <div>
            <ResultSearchBar
              campusCode={campusCode}
              setCampusCode={setCampusCode}
              courseCode={courseCode}
              setCourseCode={setCourseCode}
              onSearch={onSearch}
            />
          </div>
        </div>
        <div>
          <Table
            columns={columns}
            dataSource={res?.data}
            pagination={{
              current: pageNo,
              pageSize: config.miniPageSize,
            }}
          />
        </div>
        <div className="common-paging center">
          <Pagination
            count={res?.total || 0}
            page={pageNo}
            setPage={setPageNo}
            mini
          />
        </div>
      </Modal>
    </>
  );
}

export default SurveyResult3DetailModal;
